module.exports = __webpack_public_path__ + "img/mesto2s.abc7e5cb.png";